import React, { Component } from "react";
import cookie from "react-cookies";
import ContentLoader from "react-content-loader";
import axios from "axios";
import { format } from "date-fns";
import {
  apiUrl,
  uniqueID,
  mainAPIURL,
} from "../Settings/Config";
import {
  showOrderTime,
  showLoader,
  hideLoader,
  showDate,
} from "../Settings/SettingHelper";

class Myorders extends Component {
  constructor(props) {
    super(props);
    const customerID = localStorage.getItem("customerID") ?? "";
    this.state = {
      trigerCart: false,
      loginPopup: false,
      activeTab: "current",
      
      currentOrderPage: 1,
      currentorderList: [],
      currentordertotalPage: 0,
      currentorderhideLoadMore: false,

      loadPastOrder: true,
      pastOrderPage: 1,
      pastorderList: [],
      pastordertotalPage: 0,
      pastorderhideLoadMore: false,
      customerID: customerID,

      earnedList: [],
      redeemedList: [],
      loadReward: true,
    };
  }

  componentDidMount() {
    if (this.state.customerID === "") {
      cookie.save("triggerLogin", "Yes", { path: "/" });
      this.props.history.push("/");
    } else {
      this.loadReward();
    }
  }
  loadReward() {
    axios
      .get(`${apiUrl}customer/memberTransHistory?uniqueID=${uniqueID}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          this.setState({
            earnedList: result.earnedList,
            redeemedList: result.redeemedList,
            loadReward:false
          });
        }
      }).catch((e) => {
      });
  }

  loadRewardDisply(rewadList, rewardType) {
    return rewadList.map((item, index) => {
      let displyDate =
        item.TransactDate !== ""
          ? format(new Date(item.TransactDate.replaceAll('"', "")), "do MMM yyyy")
          : "";
      return (
        <div className="da-orders-row" key={index}>
          <div className="da-order-no">Ref No: {item.ReceiptNo} </div>
          <div
            className={`ribbon-top ${(() => {
              if (rewardType === 'Earned') {
                return "msg-recieved";
              } else if (rewardType==='Redeemed') {
                return "msg-canceled";
              }else {
                return "msg-recieved";
              }
            })()}`}
          >
            {rewardType}
          </div>

          <div className="da-order-merge-parent">
            <div className="da-order-merge-column">
              <br/>
              <div className="da-order-date-time">
                <div className="da-order-date-time-lhs">
                  <h5>{showDate(item.TransactDate)} </h5>
                </div>
                <div className="da-order-date-time-rhs">
                  <h5>{showOrderTime(`${item.TransactDate} ${item.TransactTime}`)}</h5>
                </div>
              </div>
              <br/>
            </div>
            <div className="da-reward-action">
              <div>Order Amount : <b>{item.OrderAmount}</b></div>
              <div>Points : {item.Points}</div>
            </div>
          </div>
          
        </div>
      );
    });
  }
  setTab(activeTab, e) {
    e.preventDefault();
    this.setState({ activeTab });
  }

  downloadInvoice(orderID, e) {
    e.preventDefault();
    showLoader(`invoice-${orderID}`);
    axios
      .get(
        `${apiUrl}order/generatepdf?orderID=${orderID}&uniqueID=${uniqueID}&customerID=${this.state.customerID}`
      )
      .then((res) => {
        if (res.data.status === "ok") {
          const url = `${mainAPIURL}invoice/${res.data.pdfName}`;
          window.open(url, "_blank");
          /* const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', res.data.pdfName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); */
          hideLoader(`invoice-${orderID}`);
        }
      })
      .catch((error) => {
        console.log(error);
        hideLoader(`invoice-${orderID}`);
      });
  }

  render() {
    return (
      <div className="dashboard-aside">
        {/* Order  Start  */}
        <div className="da-orders-info">
          <div className="da-orders-nav">
            <ul>
              <li
                className={this.state.activeTab === "current" ? "active" : ""}
              >
                <a href="/" onClick={this.setTab.bind(this, "current")}>
                  REWARDS EARNED
                </a>
              </li>
              <li className={this.state.activeTab === "past" ? "active" : ""}>
                <a href="/" onClick={this.setTab.bind(this, "past")}>
                  REWARDS REDEEMED
                </a>
              </li>
            </ul>
          </div>
          <div className="da-orders-tab-panel-parent">
            {this.state.activeTab === "current" && (
              <div className="da-orders-tab-panel da-orders-current reward-list">
                {console.log(this.state.loadReward, 'this.state.loadReward')}
                {this.state.loadReward === true ? (
                  <ContentLoader
                    speed={2}
                    width={400}
                    height={250}
                    viewBox="0 0 400 250"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    {...this.props}
                  >
                    {/* Title */}
                    <rect x="20" y="20" rx="5" ry="5" width="200" height="20" />

                    {/* Order ID */}
                    <rect x="20" y="50" rx="5" ry="5" width="150" height="15" />

                    {/* Customer Name */}
                    <rect x="20" y="80" rx="5" ry="5" width="180" height="15" />

                    {/* Delivery Address */}
                    <rect
                      x="20"
                      y="110"
                      rx="5"
                      ry="5"
                      width="300"
                      height="15"
                    />
                    <rect
                      x="20"
                      y="130"
                      rx="5"
                      ry="5"
                      width="250"
                      height="15"
                    />

                    {/* Contact Number */}
                    <rect
                      x="20"
                      y="160"
                      rx="5"
                      ry="5"
                      width="180"
                      height="15"
                    />

                    {/* Status Indicator */}
                    <rect
                      x="20"
                      y="190"
                      rx="5"
                      ry="5"
                      width="100"
                      height="15"
                    />
                  </ContentLoader>
                ) : this.state.earnedList.length > 0 ? (
                  <React.Fragment>
                    {this.loadRewardDisply(this.state.earnedList, 'Earned')}
                  </React.Fragment>
                ) : (
                  "No Points Found"
                )}
              </div>
            )}
            {this.state.activeTab === "past" && (
              <div className="da-orders-tab-panel da-orders-past reward-list">
                {this.state.loadReward === true ? (
                  <ContentLoader
                    speed={2}
                    width={400}
                    height={250}
                    viewBox="0 0 400 250"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    {...this.props}
                  >
                    {/* Title */}
                    <rect x="20" y="20" rx="5" ry="5" width="200" height="20" />

                    {/* Order ID */}
                    <rect x="20" y="50" rx="5" ry="5" width="150" height="15" />

                    {/* Customer Name */}
                    <rect x="20" y="80" rx="5" ry="5" width="180" height="15" />

                    {/* Delivery Address */}
                    <rect
                      x="20"
                      y="110"
                      rx="5"
                      ry="5"
                      width="300"
                      height="15"
                    />
                    <rect
                      x="20"
                      y="130"
                      rx="5"
                      ry="5"
                      width="250"
                      height="15"
                    />

                    {/* Contact Number */}
                    <rect
                      x="20"
                      y="160"
                      rx="5"
                      ry="5"
                      width="180"
                      height="15"
                    />

                    {/* Status Indicator */}
                    <rect
                      x="20"
                      y="190"
                      rx="5"
                      ry="5"
                      width="100"
                      height="15"
                    />
                  </ContentLoader>
                ) : this.state.redeemedList.length > 0 ? (
                  <React.Fragment>
                    {this.loadRewardDisply(this.state.redeemedList, 'Redeemed')}
                  </React.Fragment>
                ) : (
                  "No Points Found"
                )}
              </div>
            )}
          </div>
        </div>
        {/* Order  End */}
      </div>
    );
  }
}
export default Myorders;
